import script from "./saleOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./saleOrder.vue?vue&type=script&setup=true&lang=js"

import "./saleOrder.vue?vue&type=style&index=0&id=55e22831&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55e22831"]])

export default __exports__